import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { forexApi, type RiskConfig } from "@/lib/forex-api";

export default function RiskConfigSummaryTab() {
  const [items, setItems] = useState<RiskConfig[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    let active = true;
    setLoading(true); setError(false);
    forexApi.listRiskConfigs().then(result => { if (active) setItems(result.items); })
      .catch(() => { if (active) setError(true); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [revision]);
  return <div className="space-y-4">
    <div><h2 className="text-lg font-semibold">风控配置</h2><p className="text-sm text-text-muted">按来源查看后台风控记录。记录值不代表当前执行准入或运行生效；请结合逐账号风险结果核对。</p></div>
    <div className="flex gap-4 text-sm"><Link className="text-brand" to="/forex/kill-switch">查看 Kill Switch 操作页</Link><Link className="text-brand" to="/forex/config">查看配置中心</Link><button onClick={() => setRevision(value => value + 1)}>刷新</button></div>
    {loading && <p>正在读取风控记录…</p>}
    {!loading && error && <p role="alert">风控记录读取失败，有效状态未知。</p>}
    {!loading && !error && !items.length && <p className="rounded-lg border bg-white p-5">暂无风控记录；执行状态未知。</p>}
    {!loading && !error && !!items.length && <div className="overflow-x-auto rounded-lg border bg-white"><table className="w-full text-sm"><thead><tr className="border-b text-left"><th className="p-3">来源 / 对象</th><th className="p-3">限额记录</th><th className="p-3">Kill Switch 记录</th><th className="p-3">更新时间</th></tr></thead><tbody>{items.map(item => <tr key={item.risk_config_id} className="border-b"><td className="p-3">{item.scope}<div className="font-mono text-xs text-text-muted">{item.risk_config_id}</div></td><td className="p-3">单日 {item.daily_loss_limit} · 单周 {item.weekly_loss_limit}<div>单笔 {item.max_lot_per_trade} 手 · 总量 {item.max_total_lots} 手</div></td><td className="p-3">{item.kill_switch === "on" ? "记录为开启" : "记录为关闭"}</td><td className="p-3">{new Date(item.updated_at * 1000).toLocaleString("zh-CN")}</td></tr>)}</tbody></table></div>}
    <p className="text-xs text-text-muted">当前数据未提供有效配置版本或运行生效回读，请在逐账号风险结果中核对。</p>
  </div>;
}
